import { z } from "zod"

export const missionLinkedLayerRecordSchema = z.object({
    id: z.string(),
    mission_id: z.string(),
    org_id: z.string(),
    project_id: z.string(),
    layer_id: z.string(),
})

export const missionLinkedLayerSchema = missionLinkedLayerRecordSchema.transform((r) => ({
    id: r.id,
    missionId: r.mission_id,
    orgId: r.org_id,
    projectId: r.project_id,
    layerId: r.layer_id,
}))

export const addMissionLinkedLayersBodySchema = z.object({
    projectId: z.string(),
    layerIds: z.array(z.string()),
})

export type MissionLinkedLayerRecord = z.infer<typeof missionLinkedLayerRecordSchema>
export type MissionLinkedLayer = z.infer<typeof missionLinkedLayerSchema>
export type AddMissionLinkedLayersBody = z.infer<typeof addMissionLinkedLayersBodySchema>
